import React from "react";

import { PaymentsCreateOrderAttributes, PaymentsPrice } from "~/api/Api";
import { usePendingOrders } from "~/components/services/hooks/useOrdersWithPermissions";
import { formatPrice } from "~/helpers/helpers.ts";

import MultiSelect from "../../mantine/multiSelect/MultiSelect";
import styles from "./PricingCard.module.scss";

interface PricingCardProps {
  price: PaymentsPrice;
  targetSites: { value: string; label: string }[];
  createOrder: (order: PaymentsCreateOrderAttributes) => void;
  isCreateOrderPending?: boolean;
  list: string[];
}

export const PricingCard: React.FC<PricingCardProps> = ({
  price,
  targetSites,
  createOrder,
  isCreateOrderPending,
  list,
}) => {
  const [selectedSites, setSelectedSites] = React.useState<string[]>([]);
  const [sitesError, setSitesError] = React.useState<string | undefined>(
    undefined,
  );

  const handleOrder = () => {
    if (selectedSites.length === 0) {
      setSitesError("Please select at least one target site");

      return;
    }

    setSitesError(undefined);

    const payments_order = {
      site_ids: selectedSites.map((id) => Number(id)),
      order_items_attributes: [
        {
          price_id: price.id,
        },
      ],
    };
    createOrder(payments_order);
  };

  const { createPermission } = usePendingOrders();

  const inputId = `target-sites-${price.id}`;

  return (
    <article className={styles.pricingCard}>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <h2 className={styles.pricingCard__title}>{price.name}</h2>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <div className={styles.pricingCard__price}>
        {/*
         // @ts-expect-error TS2551 non-existing className */}
        <span className={styles.pricingCard__amount}>
          {formatPrice(price.amount, { input: "cents" })}
        </span>
        {/*
         // @ts-expect-error TS2551 non-existing className */}
        <span className={styles.pricingCard__per}>/per site</span>
      </div>
      {/*
       // @ts-expect-error TS2551 non-existing className */}
      <ul className={styles.pricingCard__features}>
        {list.map((feature) => (
          // @ts-expect-error TS2551 non-existing className
          <li key={feature} className={styles.pricingCard__feature}>
            {feature}
          </li>
        ))}
      </ul>
      <div className={styles.pricingCardTargetSites}>
        <label htmlFor={inputId} className={styles.pricingCardLabel}>
          Target sites
        </label>
        <MultiSelect
          id={inputId}
          searchable
          width={"100%"}
          disabled={!createPermission}
          data={targetSites}
          value={selectedSites}
          error={sitesError}
          placeholder="Select target sites"
          // @ts-expect-error TS2339 non-existing className
          className={styles.pricingCard__select}
          onChange={(value) => {
            setSelectedSites(value);
            if (value.length > 0) setSitesError(undefined);
          }}
          onDropdownOpen={() => setSitesError(undefined)}
        />
      </div>
      <button
        className={styles.pricingCardOrderButton}
        onClick={handleOrder}
        disabled={!createPermission || isCreateOrderPending}
      >
        Order now
      </button>
    </article>
  );
};
